/**
 * The nav and footer every public page wears.
 *
 * Their own module rather than Site.tsx so that Legal.tsx can use them without
 * a circular import -- Site.tsx routes to Legal.tsx, so Legal.tsx must not
 * import from Site.tsx.
 *
 * Shared rather than copied for a second reason: the footer carries the
 * privacy and terms links. Stripe expects those reachable from anywhere a
 * payment can start, and a copied footer is how the signup page ends up as the
 * one place they are missing.
 */

import { LEGAL } from "./legal-details";
import "./site.css";

export type Page = "home" | "pricing" | "signup" | "legal";

export function Nav({ page }: { page: Page }) {
  const current = (p: Page) => (page === p ? { color: "var(--ink)" } : undefined);

  return (
    <nav className="site-nav">
      <a className="site-nav__brand" href="/">
        <span className="site-nav__mark">⛳</span>
        Mini Golf Scoreboard
      </a>
      <div className="site-nav__links">
        <a className="site-nav__link" href="/" style={current("home")}>
          Product
        </a>
        <a className="site-nav__link" href="/pricing" style={current("pricing")}>
          Pricing
        </a>
        <a className="site-btn site-btn--ghost site-btn--sm" href="/venue">
          Venue sign in
        </a>
      </div>
    </nav>
  );
}

export function Footer() {
  return (
    <footer className="site-footer">
      <span>© {new Date().getFullYear()} {LEGAL.brand}</span>
      <a href="/pricing">Pricing</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/venue">Venue sign in</a>
      <span className="site-footer__spacer">
        First names only. No player accounts, ever.
      </span>
    </footer>
  );
}
